import {CreateAccessor, observer_mgl} from "mobx-graphlink";
import React from "react";
import {ES, Link} from "web-vcore";
import {GetWordsInDreamSegment_Array} from "../../../Server/DB/journalEntries/@JournalEntry.js";
import {store} from "../../../Store/index.js";
import {GetMapObjects} from "../../../Server/DB/mapObjects.js";
import {GetEntity} from "../../../Server/DB/entities.js";
import {MapObject} from "../../../Server/DB/mapObjects/@MapObject.js";
import {VMenuItem, VMenuStub} from "react-vmenu";
import {ACTSetCopiedData, CopiedData} from "../../../Store/main/general/CopiedData.js";
import {liveSkin} from "../../../Utils/Styles/StyleManager.js";
import {DreamScene} from "../../../Server/DB/journalEntries/$journalEntry.js";

export const GetMapObjectsPerDreamScene = CreateAccessor((mapID: string|n)=>{
	if (mapID == null) return new Map<string, MapObject[]>();
	const mapObjects = GetMapObjects(mapID);
	const result = new Map<string, MapObject[]>();
	for (const mapObject of mapObjects) {
		for (const journalSegmentPath of mapObject.journalSegmentPaths) {
			const existing = result.get(journalSegmentPath) ?? [];
			existing.push(mapObject);
			result.set(journalSegmentPath, existing);
		}
	}
	return result;
});

export const ScenePreview = observer_mgl((props: {scene: DreamScene})=>{
	const {scene} = props;
	const uiState = store.main.journal;
	const wordCount = GetWordsInDreamSegment_Array(scene.segment, "longText", false, false).length;
	const selected = uiState.sceneList_selectedScene == scene.ID();

	const selectedMapID = store.main.maps.selectedMapID;
	const mapObjectsPerScene = GetMapObjectsPerDreamScene(selectedMapID);
	const anchorEntity = scene.sceneAnchorId ? GetEntity(scene.sceneAnchorId) : null;
	const anchorLetter = anchorEntity?.name?.[0]?.toUpperCase() ?? null;

	const title = scene.sceneTitle?.length ? scene.sceneTitle : "(unnamed)";
	const infoParts = [wordCount, anchorLetter ? `${anchorLetter}` : null].filter(a=>a != null);
	const titlePlusInfo = `${title} [${infoParts.join("; ")}]`;

	return (
		<Link style={ES(
			{
				position: "relative", display: "flex", borderRadius: 5,
				backgroundColor: "rgba(255,255,255,.2)",
			},
			!mapObjectsPerScene.has(scene.ID()) && {color: "orange"},
			//selected && {color: "rgba(0,255,255,1)"},
			//selected && {backgroundColor: "rgba(100,100,0,1)"},
			selected && {textDecoration: "underline"},
		)}
			actionFunc={s=>{
				// not all journal-segments/dreams have an ID atm; so fallback to opening the journal-entry in that case
				if (scene.segment.id != null && uiState.dreamList_sidePanel_show) {
					s.main.journal.sceneList_selectedScene = scene.ID();
				} else {
					s.main.journal.selectedJournalEntry = scene.journalEntry.id;
				}
			}}
			onContextMenu={e=>e.nativeEvent["passThrough"] = true}
		>
			<VMenuStub delayEventHandler={false} preOpen={e=>!e.handled}>
				<ScenePreview_Menu scene={scene}/>
			</VMenuStub>
			<div style={{
				position: "absolute", backgroundColor: "rgba(100,150,240,0.5)",
				top: 0, left: 0, width: scene.segment.mappingProgress?.ToPercentStr() ?? "0%", height: "100%",
			}}/>
			<span style={{position: "relative"}}>{titlePlusInfo}</span>
		</Link>
	);
});

const ScenePreview_Menu = observer_mgl((props: {scene: DreamScene})=>{
	const {scene} = props;
	const headerStyle = ES(liveSkin.Style_VMenuItem(), {opacity: 1});
	return <>
		<VMenuItem text="Copy journal-path to scene" style={headerStyle} onClick={()=>{
			if (scene.segment.id == null) return;
			ACTSetCopiedData(new CopiedData({journalPath: {entryId: scene.journalEntry.id, segmentId: scene.segment.id, sceneIndex: scene.sceneIndex}}));
		}}/>
	</>;
});